import { IMember, IPhysicalAccount, IServiceWorker, IWorkerNew } from 'types';

export const isMember = (obj: { [key: string]: any }): obj is IMember => {
  return '_type' in obj && obj._type.includes('Tenant');
};

export const isWorkerNew = (obj: { [key: string]: any }): obj is IWorkerNew => {
  return '_type' in obj && obj._type.includes('Worker');
};

export const isOtherEmployee = (obj: {
  [key: string]: any;
}): obj is IServiceWorker => {
  return 'provider_id' in obj && 'id' in obj;
};

export const isPhysicalAccount = (obj: {
  [key: string]: any;
}): obj is IPhysicalAccount => {
  return !('_type' in obj) && !('provider_id' in obj);
};
